import clsx from 'clsx';
import React from 'react';
import { Button } from 'atoms/Button';
import { Link } from 'atoms/Link/Link';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { AlphabeticalItem, Group } from 'organisms/AlphabeticalItemsPage/type';
import { TKey, useTranslations } from 'modules/i18n/useTranslations';
import { getGroupBrandsByCharacters, handlePdfLink } from './helpers';
import styles from './styles.module.css';

export const AlphabeticalItemsPage = ({
  items,
  tKey,
}: {
  items: AlphabeticalItem[];
  tKey?: TKey;
}) => {
  const t = useTranslations();
  const groupedItems = getGroupBrandsByCharacters(items || []);
  const groupKeys = Object.keys(groupedItems) as Group[];

  return (
    <>
      {tKey && <h1 className={styles.title}>{t(tKey)}</h1>}

      <div className={styles.groupButtons}>
        {groupKeys.map((group) => (
          <Link href={`#${group}`} key={group}>
            <Button size="large" className={styles.button}>
              {group}
            </Button>
          </Link>
        ))}
      </div>
      <div className={styles.itemsRoot}>
        {groupKeys.map((group, idx) => (
          <div key={group} id={group} className={styles.brandGroup}>
            <div className={styles.buttonContainer}>
              <Button
                size="large"
                className={clsx(styles.button, styles[`group-${idx + 1}`])}
              >
                {group}
              </Button>
            </div>

            <div className={styles.grid}>
              {groupedItems[group].map(({ name, href, isHighlighted }, idx) => (
                <Link
                  href={handlePdfLink(href)}
                  target={'_blank'}
                  key={name + idx}
                  className={clsx(
                    styles.brandItem,
                    isHighlighted && styles.highlighted,
                  )}
                >
                  <ParseBBCode content={name} />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
